exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup {\n  width: 200px;\n  margin-left: -100px;\n  left: 50%;\n  top: 100%;\n}\n", ""]);

// exports
